export default __webpack_public_path__ + "static/media/icon-wechat-worker.e059d5f6.png";